<template>
  <div class="floor-buttons" :class="{ 'floor-buttons__scrollable': buttons.length > 7 }">
    <div id="inner-floor-buttons">
      <ButtonSquareNoIcon
        v-for="b in buttons"
        :key="b.character"
        :character="b.character"
        :activeState="b.disabled ? 'deactivated' : activeStateForButton(b)"
        size="small"
        class="floor-buttons__button"
        @clicked="changeValue(b)"
      />
    </div>
  </div>
</template>

<script>
import ButtonSquareNoIcon from '@/components/general/buttons/ButtonSquareNoIcon.vue'
import { useGeneralStore } from '@/pinia'
import { mapState as mapStatePinia } from 'pinia'

export default {
  name: 'FloorButtons',
  components: { ButtonSquareNoIcon },
  props: {
    buttons: {
      type: Array,
      default() {
        return []
      },
      validator: (values) => {
        for (let i = 0; i < values.length; i++) {
          if (!(values[i].character && values[i].emit)) {
            return false
          }
        }
        return true
      }
    },
    activeValue: {
      type: [Number, String],
      default: ''
    }
  },
  emits: ['floorChange'],
  computed: {
    ...mapStatePinia(useGeneralStore, ['showFeatureInfo'])
  },
  methods: {
    activeStateForButton(button) {
      return this.activeValue === button.character ? 'active' : 'inactive'
    },
    changeValue(button) {
      if (button.disabled) return
      this.$emit('floorChange', button.emit)
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/design-system/design-tokens/variables.scss';
@use 'src/design-system/design-tokens/mixins.scss';
@import 'src/styles/variables.scss';
.floor-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  position: absolute;
  transform: translateY(-50%);
  top: calc(85% / 2 + 30px / 2); // Same as NavVis
  max-height: 35vh; // Same as NavVis
  overflow: hidden;
  right: 28px;
  z-index: variables.$z-index-map-buttons;
  &__button {
    margin: 0px 0px 10px 0px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__scrollable {
    #inner-floor-buttons {
      overflow-y: auto;
      width: calc(#{$size-button-small} + 12px);
      @include mixins.scrollbar-vertical;
    }
  }
}
#inner-floor-buttons {
  overflow: hidden;
  width: $size-button-small;
}
@media screen and (max-width: 1024px) {
  .floor-buttons {
    align-items: center;
    bottom: 90px;
    transform: translateY(-65%);
    right: 25px;
    max-height: 240px;
  }
}
</style>
